module.exports = __webpack_public_path__ + "img/icon1.9843c382.png";